// TODO: remove in 3.0
export var DropdownItemBorderPosition;

(function (DropdownItemBorderPosition) {
  DropdownItemBorderPosition[DropdownItemBorderPosition["Top"] = 0] = "Top";
  DropdownItemBorderPosition[DropdownItemBorderPosition["Bottom"] = 1] = "Bottom";
})(DropdownItemBorderPosition || (DropdownItemBorderPosition = {}));